import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ProjectService} from "../../serverService/projectService/ProjectService";
import {
    convertUniversalDateTimeToPersianDateTime,
    dataURLtoFile,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoConfirmDialog, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoLabel,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {stringIsEmpty} from "../../util/VariableChecker";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";
import RaikoTextEditor from "../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import RaikoCustomEditor from "../../raikoComponents/raikoEditor/RaikoCustomEditor";
import RaikoCustomEditor2 from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import {FileManagerTypes} from "../../component/fileManager/FileManager";
import InternalImageSelector from "../../raikoComponents/raikoEditor/internalImageSelector/InternalImageSelector";

export default function ProjectDetail() {

    const {state} = useLocation()
    const [projectTitle, setProjectTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineProjectsDetail.name)
    const navigate = useNavigate()

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new ProjectService()

    const [postedAt, setPostedAt] = useState("")
    const [postedBy, setPostedBy] = useState("")
    const [openConFirmDialog, setOpenConfirmDialog] = useState(false);

    const openDeleteDialog = () => setOpenConfirmDialog(true)
    const closeDeleteDialog = () => setOpenConfirmDialog(false)

    const [tabValue, setTabValue] = useState(tabTypes.Detail.id)

    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }

    const {id: projectId} = useParams()

    const [buttonLoading, setButtonLoading] = useState(false)

    const [photoUrl, setPhotoUrl] = useState("");
    const [photoId, setPhotoId] = useState(-1);

    const [title, setTitle] = useState("");
    const [writerName, setWriterName] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState([])

    useEffect(() => {
        if (typeof service !== 'undefined' && typeof projectId !== 'undefined') {
            getDetailFromServer()
        }
    }, [projectId]);

    function getDetailFromServer() {
        loading.show()
        service.getProjectDetail(projectId)
            .then(response => {
                setTitle(response.title)
                setWriterName(response.authorInformation)
                setShortDescription(response.shortDescription)
                setPostedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setPostedBy(response.createdBy)

                setPhotoUrl(response.thumbnail.url)
                setPhotoId(response.thumbnail.id)

                setDescription(response.contents)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا عنوان پروژه را به درستی وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نویسنده پروژه را به درستی وارد نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه پروژه را به درستی وارد نمایید."
        else if (description.length === 0)
            message = "لطفا توضیحات پروژه را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state

    }

    function deleteNotification() {
        loading.show()
        service.deleteProject(projectId)
            .then(response => {
                    showSuccessMessage("پروژه با موفقیت حذف شد.")
                    closeDeleteDialog()
                    navigate(
                        RouteHelper.MagazineProjects.globalUrl,
                        {replace: true}
                    )
                }
            ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    function updateProjectInfo() {
        if (checkFields()) {
            loading.show()
            service.updateProjectInfo(
                projectId,
                title,
                writerName,
                photoId,
                shortDescription,
                description,
                true
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineProjectsDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openConFirmDialog}
                doAction={deleteNotification}
                pageTitle={"حذف پروژه"}
                warningTitle={"آیا از حذف پروژه اطمینان دارید؟"}
            />
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={
                                [raikoBreadCrumbItemGenerator(
                                    RouteHelper.MagazineProjects.name,
                                    RouteHelper.MagazineProjects.globalUrl
                                ), raikoBreadCrumbItemGenerator(
                                    projectTitle,
                                    ""
                                )
                                ]
                            }
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>

                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabValue}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Detail.title}
                                     value={tabTypes.Detail.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={tabTypes.Detail.id}>
                            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"پروژه"}
                                        hasActionButton={true}
                                        actionButtonTitle={"بروزرسانی"}
                                        actionButtonOnclick={updateProjectInfo}
                                        actionButtonLoadingState={buttonLoading}
                                        hasSecondaryButton={true}
                                        secondaryButtonTitle={"حذف"}
                                        secondaryButtonOnClick={openDeleteDialog}
                                    >
                                        <RaikoGridOneColumn
                                            className={css`
                                              padding: 0 1rem 1rem 1rem;
                                              max-width: 100vw;`}
                                        >
                                            <RaikoGridTwoColumn>
                                                <RaikoSimpleInputOutlined
                                                    labelText={"عنوان"}
                                                    value={title}
                                                    setValue={setTitle}
                                                />
                                                <RaikoSimpleInputOutlined
                                                    labelText={"نویسنده"}
                                                    value={writerName}
                                                    setValue={setWriterName}
                                                />
                                            </RaikoGridTwoColumn>
                                            <InternalImageSelector
                                                value={photoUrl}
                                                setValue={setPhotoUrl}
                                                imageId={photoId}
                                                setImageId={setPhotoId}
                                                bucketId={FileManagerTypes.PROJECT_IMAGES.id}
                                                title={"تصویر شاخص"}
                                            />
                                            <RaikoSimpleMultiLineInputOutlined
                                                labelText={"توضیحات کوتاه"}
                                                value={shortDescription}
                                                setValue={setShortDescription}
                                            />
                                            <RaikoSectionContainer
                                                title={"توضیحات"}
                                            >
                                                <RaikoCustomEditor2
                                                    value={description}
                                                    setValue={setDescription}
                                                />
                                            </RaikoSectionContainer>
                                        </RaikoGridOneColumn>
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>
                                <RaikoCreatorInfo createdBy={postedBy} createdAt={postedAt}/>
                            </RaikoGridOneColumn>
                        </TabPanel>
                    </TabContext>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const tabTypes = {
    Detail: {
        id: "details",
        title: "جزئیات پروژه"
    },
}
